import { Modal, Spin, Table, Tooltip } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { BiEdit } from 'react-icons/bi';
import { FaAngleDoubleLeft, FaTrashAlt } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import Spinner from '../../components/spinner';
import { getData, postData } from '../../config/api-connect';
import './style.css';

const ExpenseDetails = () => {
  var today = new Date();
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();
  yyyy = yyyy.toString();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(true);
  const [expenseData, setExpenseData] = useState();
  const [expenseType, setExpenseType] = useState();
  const [expenseId, setExpenseId] = useState(0);
  const [active, setActive] = useState(expenseId);
  // const [year, setYear] = useState(yyyy);
  // const [month, setMonth] = useState(mm);
  // const [editStatus, setEditStatus] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editId, setEditId] = useState();
  const [editAmount, setEditAmount] = useState();
  const [editExpenseTitle, setEditExpenseTitle] = useState();
  // const [type,setType]=useState(state.type)
  // const [id ,setId]=useState(state.id)

  const getExpenseDetails = useCallback(() => {
    getData(
      `/finance/get_expense_details/?expense_type=${expenseId}&year=${state.year}&month=${state.month}&type=${state.type}&id=${state.id}&venue_id=${state.venue_id}`,
    ).then((response) => {
      setExpenseData(response.data);
      setExpenseType(response.expense_types);
      setLoading(false);
    });
  }, [expenseId, state]);

  useEffect(() => {
    setLoading(true);
    getExpenseDetails();
  }, [active, expenseId, getExpenseDetails, mm, yyyy]);

  const editExpense = (item) => {
    setIsModalOpen(true);
    setEditId(item.id);
    setEditAmount(item.amount);
    setEditExpenseTitle(item.expense_title);
  };

  const renderItems = (item) => {
    return <span>{item && item.name ? item.name : '-'}</span>;
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'buddy',
      render: (item) => renderItems(item),
      key: 'name',
    },

    {
      title: 'Venue',
      dataIndex: 'venue',
      render: (item) => renderItems(item),
      key: 'names',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Expense Title',
      dataIndex: 'expense_title',
      key: 'expense_title',
    },
    {
      title: 'Month and Year',
      dataIndex: 'dates',
      key: 'dates',
    },
    {
      title: 'Actions',
      dataIndex: '',
      key: '',
      render: (item, record) => (
        <>
          <Tooltip title="Edit">
            <span>
              {expenseId !== 0 && (
                <BiEdit
                  size="1.3em"
                  onClick={() => editExpense(record)}
                  className="expense-detail-edit-icon"
                />
              )}
            </span>
          </Tooltip>
          <Tooltip title="Delete">
            <span>
              {expenseId !== 0 && <FaTrashAlt onClick={() => confirmDelete(record.id)} />}
            </span>
          </Tooltip>
        </>
      ),
    },
  ];
  const successModal = (message) => {
    Modal.success({
      title: message,
    });
  };
  const delModal = (message, id) => {
    Modal.confirm({
      title: message,
      onOk: () => {
        deleteExpense(id);
      },
    });
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onChangeValue = (item) => {
    setExpenseId(item);
    setActive(item);
  };

  // const onChangeYear = (date, dateString) => {
  //   setYear(dateString);
  // };

  const confirmDelete = (id) => {
    delModal('Do you want to delete', id);
  };

  // const confirm = (e, id) => {
  //   deleteExpense(id);
  // };

  const deleteExpense = (id) => {
    postData('/finance/delete_expense/', { expense_del_id: id })
      .then((response) => {
        successModal(response.result);
        getExpenseDetails();
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  const edit_amount = (e) => {
    setEditAmount(e.target.value);
  };
  const edit_expense_title = (e) => {
    setEditExpenseTitle(e.target.value);
  };
  const editSave = (id) => {
    postData('/finance/edit_expense_details/', {
      expense_edit_id: id,
      amount: editAmount,
      expense_title: editExpenseTitle,
    })
      .then((response) => {
        successModal(response.result);
        setLoading(true);
        getExpenseDetails();
      })
      .catch((error) => {
        alert(error.message);
      });
    setIsModalOpen(false);
  };

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <div className="expense-detail-main-container">
        <span></span>
        <div className="expense-detail-center-container">
          <div className="expense-detail-header">
            <Tooltip title="Back">
              <span className="expense-detail-back-link" onClick={() => navigate('/')}>
                <FaAngleDoubleLeft /> Back
              </span>
            </Tooltip>
            <span>Expense Details</span>
          </div>
          <div className="expense-detail-body">
            <Container>
              <Row>
                <Col>
                  {expenseType &&
                    Object.keys(expenseType).map((item, index) => (
                      <button
                        className={`expense-detail-button ${active === index ? 'active' : 'inactive'}`}
                        onClick={() => {
                          onChangeValue(item);
                        }}
                        value={item}
                        key={item}
                        name={item}
                      >
                        {' '}
                        {expenseType[item]}
                      </button>
                    ))}
                </Col>
              </Row>
            </Container>

            <Table
              rowKey="id"
              columns={columns}
              dataSource={expenseData}
              pagination={{ pageSize: 20, showSizeChanger: false }}
            />
          </div>
        </div>
      </div>

      <Modal visible={isModalOpen} onCancel={handleCancel} onOk={() => editSave(editId)}>
        <p>
          Amount{' '}
          <span className="expense-detail-amount-label">
            {' '}
            :{' '}
            <input
              className="expense-detail-input"
              type="text"
              value={editAmount}
              onChange={edit_amount}
            ></input>
          </span>
        </p>
        <p>
          Expense Title{' '}
          <span>
            :{' '}
            <input
              className="expense-detail-input"
              type="text"
              value={editExpenseTitle}
              onChange={edit_expense_title}
            ></input>
          </span>
        </p>
      </Modal>
    </Spin>
  );
};
export default ExpenseDetails;
